import { useController, useFieldArray } from "react-hook-form";
import { createValidateField } from "../../../forms/Field";
import { string } from "yup";
import { Typography } from "@mui/material";
import { FieldMessage, FormFieldWrapper } from "../../forms/FormField";
import { Check } from "@mui/icons-material";
import { useBaseInputStyles } from "../../forms/fields/baseInputStyles";
import { useCheckboxStyles } from "../../forms/fields/Checkbox";
import { formatPrice } from "../../../../utils/utils";
import { Select } from "../../forms/fields/Select";
import { makeStyles } from "../../../providers/makeStyles";

export const SelectExtrasField = ({ field, control }) => {
    const { name, paymentOptions } = field;
    const { fields, append, remove } = useFieldArray({ name, control });

    return (
        <FormFieldWrapper label={field.label}>
            {paymentOptions.extras.map(extra => <ExtraField
                key={extra.uuid}
                fieldPath={name}
                fields={fields}
                append={append}
                remove={remove}
                control={control}
                extra={extra}
                currency={paymentOptions.currency}
            />)}
        </FormFieldWrapper>
    );
};

const useStyles = makeStyles(theme => ({
    main: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1)
    },
    label: {
        marginLeft: theme.spacing(1),
    },
    price: {
        marginLeft: "auto",
        textAlign: "right",
    },
    select: {
        marginLeft: 33,
        marginTop: theme.spacing(1)
    }
}));
const ExtraField = ({ fields, append, remove, control, fieldPath, extra, currency }) => {
    const fieldIndex = fields.findIndex(field => field.uuid === extra.uuid);
    const checked = fieldIndex > -1;
    const classes = { ...useBaseInputStyles(), ...useStyles(), ...useCheckboxStyles() };

    const onChange = e => {
        if (e.target.checked) append(extra);
        else remove(fieldIndex);
    };

    return (
        <>
            <label className={classes.main}>
                <div className={classes.wrapper}>
                    <input
                        className={`${classes.baseInput} ${classes.input}`}
                        type="checkbox"
                        checked={checked}
                        onChange={onChange}
                    />
                    {checked && <Check className={classes.check}/>}
                </div>
                <div className={classes.label}>
                    <Typography>{extra.name}</Typography>
                </div>
                <div className={classes.price}>
                    <Typography color="textSecondary">{formatPrice(extra.price, currency)}</Typography>
                </div>
            </label>
            {checked && extra.options?.length > 0 &&
            <div className={classes.select}>
                <ExtraOptionsField index={fieldIndex} control={control} fieldPath={fieldPath} options={extra.options}/>
            </div>}
        </>
    );
};

const ExtraOptionsField = ({ index, fieldPath, control, options }) => {
    const { field: input, fieldState } = useController({
        control,
        name: `${fieldPath}.${index}.size`,
        rules: { validate: createValidateField(string().required("You need to select an option")) }
    });
    const field = {
        options: [
            { label: "", value: null },
            ...options.map(option => ({ label: option, value: option }))
        ]
    };

    return (
        <div>
            <Select field={field} input={input} hasError={!!fieldState.error}/>
            <FieldMessage errorMessage={fieldState.error?.message}/>
        </div>
    );
};
